import React from "react";
import { withRouter } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import CachedIcon from "@material-ui/icons/Cached";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import Box from "../../../../../../ui/Box";
import SquareButton from "../../../../../../ui/SquareButton";
import Button from "../../../../../../ui/Button";
import ActionsMenu from "../../../../../../ui/ActionsMenu";
import UndoIcon from '@material-ui/icons/Undo';

const useStyles = makeStyles(() => ({
  topBar: {
    display: "flex",
    justifyContent: "space-between"
  },
  topBarLeft: {
    display: "flex",
    "& > button": {
      marginRight: 12
    }
  },
  topBarRight: {
    display: "flex",
    "& > div": {
      marginLeft: 12
    }
  }
}));

const TopBar = ({
  reload,
  returnBack,
  openDeleteModal,
  openAcceptModal,
  openDeclineModal,
  openRestoreModal,
  isAcceptingRequest,
  isDecliningRequest,
  isUpdatingRequest,
  isRestoringRequest,
  isFormValid,
  updateRequest,
  reloadRequest,
  validateForm,
  statusId,
  disabled,
  editmode,
  setEditMode,
  setViewMode }) => {
  const classes = useStyles();

  const actions = [
    {
      label: "Удалить заявку",
      onClick: openDeleteModal
    }
  ];

  return (
    <Box>
      <div className={classes.topBar}>
        <div className={classes.topBarLeft}>
          <SquareButton onClick={returnBack}>
            <ChevronLeftIcon fontSize="small" />
          </SquareButton>
          <SquareButton onClick={reload}>
            <CachedIcon fontSize="small" />
          </SquareButton>
        </div>
        <div className={classes.topBarRight}>
          {editmode
            ? (<>
             <SquareButton onClick={setViewMode} title="Вернуться в режим просмотра">
               <UndoIcon fontSize="small" />
             </SquareButton>
             <div></div>
             <Button
               onClick={updateRequest}
               loading={isUpdatingRequest}
               disabled={disabled}
               color="green">
               СОХРАНИТЬ
             </Button>
             </>)
          : (<>
            { statusId === 0
              ? (<><Button
                 onClick={setEditMode}
                 color="gray">
                 Редактировать
               </Button>
               <div></div>
               <Button
                 onClick={openDeclineModal}
                 loading={isDecliningRequest}
                 disabled={disabled}
                 color="pink">
                 ОТКЛОНИТЬ
               </Button>
               <div></div>
               <Button
                 onClick={openAcceptModal}
                 loading={isAcceptingRequest}
                 disabled={disabled}
                 color="green">
                 ПОДТВЕРДИТЬ
               </Button></>
             )
             : (statusId<0 &&
                 (<>
                   <div></div>
                   <Button
                     onClick={openRestoreModal}
                     loading={isRestoringRequest}
                     disabled={disabled}
                     color="gray">
                     ВОЗОБНОВИТЬ
                   </Button>  </>
                 )
             )}</>)}
          <ActionsMenu actions={actions} />
        </div>
      </div>
    </Box>
  );
};

export default withRouter(TopBar);
